module.exports = __webpack_public_path__ + "img/hramR.2852da01.png";